import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

export default function HeroProduct() {
  const { t } = useLanguage();
  const waLink = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent("Hola Amaranto, quiero apartar la Bombonera de Peonía.")}`;
  const h = t.heroProduct;

  return (
    <section id="hero-product" data-testid="hero-product-section" className="bg-champagne/40 py-28 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1.2 }}
          className="md:col-span-7 group"
        >
          <div className="relative overflow-hidden aspect-[4/5]">
            <img src="/catalog/img13.jpg" alt={`${h.title1} ${h.title2}`}
              className="w-full h-full object-cover transition-transform duration-[1600ms] group-hover:scale-[1.03]" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1.1, delay: 0.15 }}
          className="md:col-span-5"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-warmbrown" />
            <span className="eyebrow">{h.eyebrow}</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
            {h.title1}
            <br />
            <span className="italic font-normal text-warmbrown">{h.title2}</span>
          </h2>
          <p className="font-serif italic text-lg md:text-xl text-ink-soft mt-6 max-w-md">{h.sub}</p>

          <ul className="mt-10 space-y-3 font-body text-sm md:text-base text-ink-soft leading-relaxed">
            {h.bullets.map((b, i) => (
              <li key={i} className="flex gap-3 items-start">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-dustyrose-deep shrink-0" />
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex items-baseline gap-4">
            <p className="font-serif text-3xl text-ink">{h.price}</p>
            <p className="font-body text-xs uppercase tracking-[0.22em] text-ink-soft">{h.shipping}</p>
          </div>

          <a href={waLink} target="_blank" rel="noreferrer" data-testid="hero-product-cta"
            className="inline-flex items-center gap-3 mt-10 bg-ink hover:bg-dustyrose-deep text-cream px-10 py-4 text-[11px] tracking-[0.3em] uppercase font-semibold transition-all duration-500">
            {h.cta} →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
